<template>
  <el-row :gutter="5">
    <el-col :style="`width: ${width}%`">
      <TravelNavigator
        @expand="resize"
        @address="add"
        @generate="generate"
        :currentCustomers="markersData"
      />
    </el-col>
    <el-col v-if="width === 15" :style="`width: ${100 - width}%`">
      <TravelMap ref="travelMap" class="travel-map" :markers="markers" />
    </el-col>
  </el-row>
</template>

<script>
import TravelMap from "./TravelMap";
import TravelNavigator from "./TravelNavigator.vue";

export default {
  components: {
    TravelMap,
    TravelNavigator,
  },

  props: {
    markersData: Array,
  },

  data() {
    return {
      width: 90,
      markers: [],
    };
  },

  methods: {
    resize(minus) {
      this.width = minus ? 15 : 90;
    },
    add(mapData) {
      this.markers.push(mapData);
      this.$emit("data", this.markers);
    },

    generate(customerList) {
      this.markers = customerList.map((x) => x.customerData);
      this.$emit("data", this.markers);
    },
  },

  mounted() {
    if (this.markersData) this.markers.push(...this.markersData);
  },
};
</script>
